export default "__VITE_ASSET__DAM7GkA7__"